<template>
  <div>
    <bread-crumb></bread-crumb>
    <top-bar
      :isShowSelect="showOrHidden.isShowTopBar"
      placeholder="请选择所属业务"
      :data="belongBussinessList"
      :clickAddButton="clickAddButton"
      @selectChange="selectChange"
      :clearable="clearable"
    >
      <div class="searchIpt-all">
        <el-input
          clearable
          v-model="searchInfo.userAccount"
          placeholder="输入ERP或京东PIN"
          class="searchIpt"
          size="small"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchIpt-btn"
          size="small"
          @click="searchClick"
        >
          搜索
        </el-button>
      </div>
    </top-bar>
    <div class="contentShow">
      <el-tabs v-model="activeName" @tab-click="switchStatus">
        <el-tab-pane name="all">
          <span slot="label" class="slot-item">
            <span>全部</span>
            <span>{{ businessAccountCountStaus.totalCount }}</span>
          </span>
          <!-- v-if="oTableDate.tableList && oTableDate.tableList.length" -->
          <base-table
            class="contentShow-header"
            :tableData="oTableDate"
            :isFreezeShow="false"
            @handleClick="TabhandleClick"
            :activeName="activeName"
          />
        </el-tab-pane>
        <el-tab-pane name="pending">
          <span slot="label" class="slot-item">
            <span>待审核</span>
            <span>{{ businessAccountCountStaus.unAuditCount }}</span>
          </span>
          <!-- v-if="oTableDate.tableList && oTableDate.tableList.length" -->
          <base-table
            :isFreezeShow="false"
            :tableData="oTableDate"
            @handleClick="TabhandleClick"
            :activeName="activeName"
          />
        </el-tab-pane>
        <el-tab-pane name="passed">
          <span slot="label" class="slot-item">
            <span>已通过</span>
            <span>{{ businessAccountCountStaus.passAuditCount }}</span>
          </span>
          <!-- v-if="oTableDate.tableList && oTableDate.tableList.length" -->
          <base-table
            :isFreezeShow="false"
            :tableData="oTableDate"
            @handleClick="TabhandleClick"
            :activeName="activeName"
          />
        </el-tab-pane>
        <el-tab-pane name="rejected">
          <span slot="label" class="slot-item">
            <span>已驳回</span>
            <span>{{ businessAccountCountStaus.rejectAuditCount }}</span>
          </span>
          <!-- v-if="oTableDate.tableList && oTableDate.tableList.length" -->
          <base-table
            :isFreezeShow="false"
            :tableData="oTableDate"
            @handleClick="TabhandleClick"
            :activeName="activeName"
          />
        </el-tab-pane>
        <el-tab-pane name="frozen">
          <span slot="label" class="slot-item">
            <span>已冻结</span>
            <span>{{ businessAccountCountStaus.frozenCount }}</span>
          </span>
          <!-- v-if="oTableDate.tableList && oTableDate.tableList.length" -->
          <base-table
            :isFreezeShow="false"
            :tableData="oTableDate"
            @handleClick="TabhandleClick"
            :activeName="activeName"
          />
        </el-tab-pane>
      </el-tabs>
      <pagination
        @sizePageChange="paginationChangeProduct"
        :paginationDatas="paginationDataProduct"
      />
    </div>
    <modal
      :isShow.sync="showOrHidden.isShowAddAccountModal"
      title="新增业务账号"
      :width="width"
      :btnText="btnText.ordinaryBtnText"
      :isShowBtn="showOrHidden.isShowBtn"
      @clickHandler="addNewBusinessAccountClickHandler"
    >
      <el-form
        :model="modalData"
        :rules="modalData.rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="运营账号" prop="addAccount">
          <el-select
            v-model="modalData.addAccount.accountType"
            placeholder="选择账号类型"
            size="small"
            class="width90 marRig4"
            clearable
          >
            <el-option
              v-for="(item, index) in accountTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            v-model="modalData.addAccount.accountPinOrErp"
            placeholder="京东内部ERP或京东PIN"
            size="small"
            minlength="1"
            maxlength="20"
            show-word-limit
            class="width182"
          />
        </el-form-item>
        <el-form-item
          label=" 所属业务"
          prop="belongBusinessId"
          class="operating-account"
        >
          <el-select
            v-model="modalData.belongBusinessId"
            size="small"
            placeholder="请选择"
            class="width276"
          >
            <el-option
              v-for="item in belongBussinessList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配角色" prop="roleIdList">
          <el-checkbox-group v-model="modalData.roleIdList">
            <el-checkbox
              v-for="item in roleListData"
              :key="item.roleId"
              :label="item.roleId"
            >
              {{ item.roleName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </modal>

    <modal
      :isShow.sync="showOrHidden.isShowAuditModal"
      title="审核"
      width="414px"
      :isShowBtn="showOrHidden.isShowBtn"
      :btnText="btnText.btnTextAuditModal"
      @clickHandler="auditClickHandler"
    >
      <el-form
        :model="modalData"
        ref="auditDom"
        :rules="modalData.rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="申请理由" prop="targetLineInfo.applyRemarks">
          <span>{{ modalData.targetLineInfo.applyRemarks }}</span>
        </el-form-item>
        <el-form-item label="分配角色" prop="roleIdList">
          <el-checkbox-group v-model="modalData.roleIdList">
            <el-checkbox
              v-for="item in roleListData"
              :key="item.roleId"
              :label="item.roleId"
            >
              {{ item.roleName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </modal>

    <modal
      :isShow.sync="showOrHidden.isShowRejectModal"
      title="审核"
      width="414px"
      :isShowBtn="showOrHidden.isShowBtn"
      :btnText="btnText.btnTextRejectModal"
      @clickHandler="rejectClickHandler"
    >
      <el-form
        :model="modalData"
        ref="rejectDom"
        :rules="modalData.rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="栏目名" prop="targetLineInfo.applyRemarks">
          <span>{{ modalData.targetLineInfo.applyRemarks }}</span>
        </el-form-item>
        <el-form-item label="审核结果" prop="roleId">
          <span>驳回</span>
        </el-form-item>
        <el-form-item label="驳回理由" prop="rejectReason">
          <el-input
            size="small"
            type="textarea"
            placeholder="不超过150字的描述"
            v-model="modalData.rejectReason"
            maxlength="150"
            show-word-limit
            class="rejectInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>

    <modal
      :isShow.sync="showOrHidden.isShowFreezeModal"
      title="冻结"
      :width="width"
      :isShowBtn="showOrHidden.isShowBtn"
      :btnText="btnText.ordinaryBtnText"
      @clickHandler="freezeClickHandler"
    >
      <el-form
        :model="modalData"
        ref="freezeDom"
        :rules="modalData.rules"
        label-width="100px"
      >
        <el-form-item label="冻结理由" prop="freezeReason" class="freezeDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="不超过150字的描述"
            v-model="modalData.freezeReason"
            maxlength="150"
            show-word-limit
            class="freezeInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>

    <modal
      :isShow.sync="showOrHidden.isShowEditRoleModal"
      title="修改角色"
      :width="width"
      :isShowBtn="showOrHidden.isShowBtn"
      :btnText="btnText.ordinaryBtnText"
      @clickHandler="editroleClickHandler"
    >
      <el-form
        :model="modalData"
        label-width="100px"
        ref="editRole"
        :rules="modalData.rules"
        class="demo-ruleForm"
      >
        <el-form-item label="业务账号" prop="addAccount">
          <el-select
            v-model="modalData.addAccount.accountType"
            placeholder="选择账号类型"
            size="small"
            class="width90 marRig4"
            disabled
          >
            <el-option
              v-for="(item, index) in accountTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            v-model="modalData.addAccount.accountPinOrErp"
            placeholder="京东内部ERP或京东PIN"
            size="small"
            class="width182"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label=" 业务名称" prop="belongBusinessId">
          <el-select
            v-model="modalData.belongBusinessId"
            placeholder="请选择"
            size="small"
            class="width276"
            disabled
          >
            <el-option
              v-for="item in belongBussinessList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配角色" prop="roleIdList">
          <el-checkbox-group v-model="modalData.roleIdList">
            <el-checkbox
              v-for="item in roleListData"
              :key="item.roleId"
              :label="item.roleId"
            >
              {{ item.roleName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </modal>
    <modal
      :isShow.sync="showOrHidden.isShowReasonModal"
      title="查看理由"
      :width="width"
      :isShowBtn="showOrHidden.isShowBtn"
      :btnText="btnText.ordinaryBtnText"
      @clickHandler="viewReasonClick"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <div class="reasonDom">
          {{ modalData.reason }}
        </div>
      </el-form>
    </modal>
  </div>
</template>

<script>
import baseTable from "../../../../components/baseTable";
import topBar from "../../../../components/topBar";
import breadCrumb from "../../../../components/breadCrumb";
import pagination from "../../../../components/pagination";
import {
  pageQueryBusinessAccount,
  addNewBusinessAccount,
  pageContentRole,
  listContentBusinessForUserMan, //获取运营关联的业务信息
  reviewBusinessAccount, //审核业务账号
  updateBusinessAccountRole, //修改业务账号
  queryBusinessAccountCount, //业务账号各状态的数量
  changheBusinessAccountStatus, //更改创作者状态
} from "../../../../api/man";
import modal from "../../../../components/modal";
export default {
  name: "manAudit",
  components: {
    topBar,
    breadCrumb,
    baseTable,
    modal,
    pagination,
  },
  data() {
    return {
      activeName: "all",
      width: "414px",
      searchInfo: {
        bussinessId: "",
        userAccount: "",
      },
      clearable: "clearable",
      showOrHidden: {
        isShowBtn: [true, true], //弹窗是否能显示按钮
        isShowTopBar: true, //是否显示顶部top-bar组件
        isShowAddAccountModal: false, //添加业务账号弹窗
        isShowAuditModal: false, //是否显示审核弹窗
        isShowRejectModal: false, //是否显示驳回弹窗
        isShowFreezeModal: false, //是否显示冻结窗口
        isShowEditRoleModal: false, //是否显示修改角色弹窗
        isShowReasonModal: false, //查看理由弹窗
      },
      businessAccountCountStaus: {},
      btnText: {
        // btnTopBarText: ["取消", "确认"],
        ordinaryBtnText: ["取消", "确认"],
        btnTextAuditModal: ["驳回", "通过"],
        btnTextRejectModal: ["取消", "提交"],
      },
      belongBussinessList: [], //运营业务数据集合
      roleListData: [], //角色数据集合
      accountTypeList: [
        {
          label: "JD账号",
          value: 2,
        },
        {
          label: "ERP账号",
          value: 1,
        },
        {
          label: "其他账号",
          value: 3,
        },
      ],
      modalData: {
        name: "",
        belongBusinessId: "", //所属业务ID
        roleIdList: [], //角色集合
        targetLineInfo: {
          applyRemarks: "",
        },
        rejectReason: "",
        freezeReason: "",
        accountType: "",
        reason: "",
        addAccount: {
          accountType: "",
          accountPinOrErp: "",
        },
        rules: {
          name: [
            {
              required: true,
              message: "请输入京东内部ERP或京东PIN",
              trigger: "blur",
            },
            {
              min: 1,
              max: 20,
              message: "长度在 1 到 20 个字符",
              trigger: "blur",
            },
          ],
          addAccount: [
            {
              required: true,
              trigger: ["blur"],
            },
            {
              validator(rule, value, callback) {
                if (!value.accountType && value.accountPinOrErp) {
                  callback(new Error("请选择账号类型"));
                } else if (value.accountType && !value.accountPinOrErp) {
                  callback(new Error("请输入京东内部ERP或京东PIN"));
                } else if (!value.accountType && !value.accountPinOrErp) {
                  callback(
                    new Error("请选择账号类型和输入京东内部ERP或京东PIN")
                  );
                } else {
                  callback();
                }
              },
            },
          ],
          roleIdList: [
            {
              required: true,
              message: "至少选择一个角色",
              trigger: "blur",
            },
          ],
          belongBusinessId: [
            { required: true, message: "请选择", trigger: "change" },
          ],
          checkoutData: [
            { required: true, message: "至少选择一项", trigger: "change" },
          ],
          rejectReason: [
            {
              required: true,
              message: "请输入驳回理由",
              trigger: "blur",
            },
          ],
          freezeReason: [
            {
              required: true,
              message: "请输入冻结理由",
              trigger: "change",
            },
          ],
        },
      },
      oTableDate: {
        tableList: [],
        tableHeader: [
          {
            label: "审核ID",
            prop: "id",
          },
          {
            label: "ERP或京东PIN",
            prop: "contentUserMan",
          },
          {
            label: "所属业务",
            prop: "contentBusiness",
          },
          {
            label: "申请理由",
            prop: "applyRemarks",
          },
          {
            label: "角色",
            prop: "roleList",
          },
          {
            label: "审核时间",
            prop: "auditTime",
          },
          {
            label: "更新时间",
            prop: "updateTime",
          },
          {
            label: "审核人",
            prop: "auditPin",
          },
          {
            label: "状态",
            prop: "auditStatus",
            tableStatus: "auditStatus",
          },
        ],
        tableType: 7,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      auditStatusType: "all", //bugfix:用来表示表格数据所属的数据集
      businessIdMark: "", //bugfix：处理没有点击搜索 依旧搜索
      searchPinMark: "",
    };
  },
  methods: {
    //初始化分页器
    // initializePage(){
    //   this.paginationDataProduct= {
    //     total: 0,
    //       currentPage: 1,
    //       pageSize: 10
    //   }
    // },
    //新增业务弹窗
    clickAddButton(arg) {
      this.getPageContentRole();
      this.modalData.belongBusinessId = "";
      this.modalData.roleIdList = [];
      this.showOrHidden.isShowAddAccountModal = true;
    },
    selectChange(arg) {
      this.searchInfo.bussinessId = arg;
    },
    //筛选数据
    searchClick() {
      let auditStatusTypeNum = {
        auditStatus: "",
        accountStatus: "",
      };
      //bugfix:处理查询时 没有关联查询时状态 造成状态数量一直是总的数量 没有针对当前的数据体
      this.auditStatusType = this.activeName;
      switch (this.auditStatusType) {
        case "pending":
          auditStatusTypeNum.auditStatus = 1;
          break;
        case "passed":
          auditStatusTypeNum.auditStatus = 2;
          break;
        case "rejected":
          auditStatusTypeNum.auditStatus = 3;
          break;
        case "frozen":
          auditStatusTypeNum.accountStatus = 3;
          break;
      }
      this.searchInfo.bussinessId
        ? (this.businessIdMark = this.searchInfo.bussinessId)
        : (this.businessIdMark = null);
      this.searchInfo.userAccount
        ? (this.searchPinMark = this.searchInfo.userAccount)
        : (this.searchPinMark = null);
      if (this.searchInfo.bussinessId || this.searchInfo.userAccount) {
        let searchParmas = {};
        if (auditStatusTypeNum.accountStatus) {
          searchParmas = {
            tenantId: this.$commonJs.getTenantId(),
            pageNo: 1,
            pageSize: this.paginationDataProduct.pageSize,
            searchPin: this.searchPinMark || null,
            accountStatus: auditStatusTypeNum.accountStatus || null,
            businessId: this.businessIdMark || null,
          };
        } else {
          searchParmas = {
            tenantId: this.$commonJs.getTenantId(),
            pageNo: 1,
            pageSize: this.paginationDataProduct.pageSize,
            searchPin: this.searchPinMark || null,
            auditStatus: auditStatusTypeNum.auditStatus || null,
            businessId: this.businessIdMark || null,
          };
        }
        // this.auditStatusType='all'
        this.BusinessAccountInfo(searchParmas);
      } else {
        let searchNullParmas = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          auditStatus: auditStatusTypeNum.auditStatus || null,
        };
        this.BusinessAccountInfo(searchNullParmas);
      }
    },
    //新增业务账号
    addNewBusinessAccountClickHandler(arg) {
      if (arg === "two") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.addNewBusinessAccount();
          } else {
            return false;
          }
        });
      } else {
        this.showOrHidden.isShowAddAccountModal = false;
        this.modalData.roleIdList = []; //点击操作后将数据源置空
        this.modalData.belongBusinessId = "";
        this.modalData.addAccount = {
          accountType: "",
          accountPinOrErp: "",
        };
      }
    },
    //获取筛选数据状态
    switchStatus(tab, event) {
      //bugfix：如果bussinessId为空不点击查询 请求时businessId没有更新 --->自动给同步this.businessIdMark（不需点击查询，就能及时更新）
      if (!this.searchInfo.bussinessId) {
        this.businessIdMark = "";
      } else if (!this.searchInfo.userAccount) {
        this.searchPinMark = "";
      }
      if (this.activeName === "all") {
        let searchParmas = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          businessId: this.businessIdMark || null,
          searchPin: this.searchPinMark || null,
        };
        this.auditStatusType = "all";
        this.BusinessAccountInfo(searchParmas);
      } else if (this.activeName === "pending") {
        let searchParmas = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          auditStatus: 1,
          businessId: this.businessIdMark || null,
          searchPin: this.searchPinMark || null,
        };
        this.auditStatusType = "pending";
        this.BusinessAccountInfo(searchParmas);
      } else if (this.activeName === "passed") {
        let searchParmas = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          auditStatus: 2,
          businessId: this.businessIdMark || null,
          searchPin: this.searchPinMark || null,
        };
        this.auditStatusType = "passed";
        this.BusinessAccountInfo(searchParmas);
      } else if (this.activeName === "rejected") {
        let searchParmas = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          auditStatus: 3,
          businessId: this.businessIdMark || null,
          searchPin: this.searchPinMark || null,
        };
        this.auditStatusType = "rejected";
        this.BusinessAccountInfo(searchParmas);
      } else if (this.activeName === "frozen") {
        let searchParmas = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: 1,
          pageSize: this.paginationDataProduct.pageSize,
          accountStatus: 3,
          businessId: this.businessIdMark || null,
          searchPin: this.searchPinMark || null,
        };
        this.auditStatusType = "frozen";
        this.BusinessAccountInfo(searchParmas);
      }
    },
    //获取tab行点击类型
    TabhandleClick(propData) {
      console.log("propData", propData);
      // modalData: {
      //   name: "",
      //   belongBusinessId: "", //所属业务ID
      //   roleIdList: [],//角色集合
      //   targetLineInfo: {
      //     applyRemarks: "",
      //   },
      this.getPageContentRole();
      this.modalData.targetLineInfo = propData.val;
      switch (propData.type) {
        case "audit":
          this.showOrHidden.isShowAuditModal = true;
          this.modalData.roleIdList =
            propData.val.contentUserMan.contentRoles.map((item) => {
              return item.id;
            });
          break;
        case "freeze":
          this.showOrHidden.isShowFreezeModal = true;
          break;
        case "editrole":
          this.modalData.addAccount.accountType =
            propData.val.contentUserMan.pinType;
          this.modalData.addAccount.accountPinOrErp =
            propData.val.contentUserMan.pin;
          this.modalData.belongBusinessId = propData.val.contentBusiness.id;
          this.modalData.roleIdList =
            propData.val.contentUserMan.contentRoles.map((item) => {
              return item.id;
            });
          this.showOrHidden.isShowEditRoleModal = true;
          break;
        case "thaw":
          // this.showOrHidden.isShowFreezeModal = true;
          this.changheBusinessAccountStatus(propData.val, propData.type);
          break;
        case "examine":
          this.viewReason(this.modalData.targetLineInfo);
          break;
      }
    },
    //审核弹窗按钮
    auditClickHandler(arg) {
      if (arg === "two") {
        this.$refs.auditDom.validate((valid) => {
          if (valid) {
            this.modalData.targetLineInfo.auditStatus = 2;
            this.ReviewBusinessAccount(this.modalData.targetLineInfo, "passed");
            this.showOrHidden.isShowAuditModal = false;
            this.modalData.roleIdList = []; //点击操作后将数据源置空
          } else {
            return false;
          }
        });
      } else {
        this.showOrHidden.isShowAuditModal = false;
        this.showOrHidden.isShowRejectModal = true;
      }
    },
    //驳回弹窗按钮
    rejectClickHandler(arg) {
      if (arg === "two") {
        this.$refs.rejectDom.validate((valid) => {
          if (valid) {
            this.modalData.targetLineInfo.auditStatus = 3;
            this.ReviewBusinessAccount(
              this.modalData.targetLineInfo,
              "rejected"
            );
            this.showOrHidden.isShowRejectModal = false;
            this.modalData.roleIdList = []; //点击操作后将数据源置空
            this.modalData.rejectReason = "";
          } else {
            return false;
          }
        });
      } else {
        this.showOrHidden.isShowRejectModal = false;
        this.modalData.roleIdList = []; //点击操作后将数据源置空
        this.modalData.rejectReason = "";
      }
    },
    //冻结弹窗
    freezeClickHandler(arg) {
      console.log(
        "this.modalData.targetLineInfo",
        this.modalData.targetLineInfo
      );

      if (arg === "two") {
        this.$refs.freezeDom.validate((valid) => {
          if (valid) {
            let params = {
              tenantId: this.$commonJs.getTenantId(),
              contentUserManId: this.modalData.targetLineInfo.contentUserManId,
              contentBusinessId:
                this.modalData.targetLineInfo.contentBusinessId,
              accountStatus: 3,
              auditRemarks: this.modalData.freezeReason,
            };

            this.changheBusinessAccountStatus(
              this.modalData.targetLineInfo,
              "freeze"
            );
            this.showOrHidden.isShowFreezeModal = false;
            this.modalData.roleIdList = []; //点击操作后将数据源置空
            this.modalData.freezeReason = "";
          } else {
            return false;
          }
        });
      } else {
        this.showOrHidden.isShowFreezeModal = false;
        this.modalData.freezeReason = "";
      }
    },
    //修改角色弹窗
    editroleClickHandler(arg) {
      if (arg === "two") {
        this.$refs.editRole.validate((valid) => {
          if (valid) {
            this.updateBusinessAccountRole(
              this.modalData.targetLineInfo,
              this.modalData.roleIdList
            );
            this.showOrHidden.isShowEditRoleModal = false;
            this.modalData.roleIdList = []; //点击操作后将数据源置空
            this.modalData.belongBusinessId = "";
            this.modalData.addAccount = {
              accountType: "",
              accountPinOrErp: "",
            };
          } else {
            return false;
          }
        });
      } else {
        this.showOrHidden.isShowEditRoleModal = false;
        this.modalData.roleIdList = []; //点击操作后将数据源置空
        this.modalData.belongBusinessId = "";
        this.modalData.addAccount = {
          accountType: "",
          accountPinOrErp: "",
        };
      }
    },
    //查看理由
    viewReason(lineInfo) {
      this.showOrHidden.isShowReasonModal = true;
      this.modalData.reason = lineInfo.auditRemarks;
    },
    viewReasonClick(arg) {
      this.showOrHidden.isShowReasonModal = false;
      this.modalData.reason = "";
    },
    //分页查询业务账号
    BusinessAccountInfo(searchParmas) {
      if (!searchParmas) {
        searchParmas = {
          tenantId: this.$commonJs.getTenantId(),
          pageNo: this.paginationDataProduct.currentPage,
          pageSize: this.paginationDataProduct.pageSize,
        };
      }
      // this.initializePage()
      console.log("接口入参", searchParmas);
      pageQueryBusinessAccount(searchParmas).then((res) => {
        console.log("接口出参", res);
        //bug：为空时，页码错误
        res.totalCount === 0
          ? (this.paginationDataProduct.currentPage = 1)
          : this.paginationDataProduct.currentPage;
        this.oTableDate.tableList.splice(0, this.oTableDate.tableList.length);
        res.data.map((ele) => {
          this.oTableDate.tableList.push(ele);
          let tem = [];
          ele.contentUserMan.contentRoles
            ? ele.contentUserMan.contentRoles.forEach((item) => {
                tem.push(item.roleName);
              })
            : null;
          ele.roleList = tem.join(" ");
          //冻结账户状态转换
          if (ele.accountStatus === 3) {
            ele.auditStatus = 4;
          }
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        this.getAllArticleCounts(searchParmas);
      });
    },
    //获取角色信息
    getPageContentRole() {
      pageContentRole({
        tenantId: this.$commonJs.getTenantId(),
        pageSize: 100, //和后端协商 100
        pageNo: 1,
      }).then((res) => {
        //bugfix: 同步更新角色信息
        if (this.roleListData.length > 0) {
          this.roleListData = [];
        }
        res.data.forEach((ele) => {
          this.roleListData.push({
            roleName: ele.roleName,
            roleId: ele.id,
          });
        });
      });
    },
    //新增业务账号
    addNewBusinessAccount() {
      const arr = this.modalData.roleIdList.map((item) => ({ id: item }));
      addNewBusinessAccount({
        tenantId: this.$commonJs.getTenantId(),
        pin: this.modalData.addAccount.accountPinOrErp,
        pinType: this.modalData.addAccount.accountType,
        contentBusinesses: [{ id: this.modalData.belongBusinessId }],
        contentRoles: arr,
        // : this.modalData.targetLineInfo.pin,
      })
        .then((res) => {
          this.BusinessAccountInfo();
          this.showOrHidden.isShowAddAccountModal = false;
          this.modalData.roleIdList = []; //点击操作后将数据源置空
          this.modalData.belongBusinessId = "";
          this.modalData.addAccount = {
            accountType: "",
            accountPinOrErp: "",
          };
        })
        .catch((err) => {
          if (err.code == 1407) {
            this.$message({
              message: err.msg,
              type: "warning",
            });
          } else if (err.code == 1408) {
            this.$message({
              message: err.msg,
              type: "warning",
            });
          }
        });
    },
    //获取运营相关的业务信息
    getListContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((ele) => {
          this.belongBussinessList.push({
            label: ele.name,
            value: ele.id,
          });
        });
      });
    },
    //审核业务账号
    ReviewBusinessAccount(propData, type) {
      this.activeName = type;
      console.log(propData);
      reviewBusinessAccount({
        tenantId: this.$commonJs.getTenantId(),
        contentUserManId: propData.contentUserManId,
        contentBusinessId: propData.contentBusinessId,
        auditStatus: propData.auditStatus,
        pin: propData.pin,
        auditRemarks: this.modalData.rejectReason,
        roleIds: this.modalData.roleIdList, //bugfix: 角色权限控制（后台新加接口）
      }).then((res) => {
        if (type == "rejected") {
          //bug：点击待审核  待审核审核后 直接拉取的是所有文章 但是状态还在待审核上
          let searchParmas = {
            tenantId: this.$commonJs.getTenantId(),
            pageNo: this.paginationDataProduct.currentPage,
            pageSize: this.paginationDataProduct.pageSize,
            auditStatus: 3,
          };
          this.BusinessAccountInfo(searchParmas);
        } else if (type == "passed") {
          let searchParmas = {
            tenantId: this.$commonJs.getTenantId(),
            pageNo: this.paginationDataProduct.currentPage,
            pageSize: this.paginationDataProduct.pageSize,
            auditStatus: 2,
          };
          this.BusinessAccountInfo(searchParmas);
        } else {
          this.BusinessAccountInfo();
        }
        // if(res){
        //   this.BusinessAccountInfo()
        // }
      });
    },
    //修改业务账号
    updateBusinessAccountRole(LineInfo, roleIdList) {
      console.log("修改业务账号", LineInfo);
      const arr = roleIdList.map((item) => ({ id: item }));
      updateBusinessAccountRole({
        tenantId: LineInfo.tenantId,
        id: LineInfo.contentUserMan.id,
        contentRoles: arr,
        pin: LineInfo.contentUserMan.pin,
      }).then((res) => {
        this.$message.success("修改成功");
        this.BusinessAccountInfo();
      });
    },
    // 分页
    paginationChangeProduct(val) {
      //bugfix：在其他数据状态下 点击分页器 请求的都是全部 造成bug
      if (this.auditStatusType) {
        let parmasByType = {
          auditStatus: "",
          accountStatus: "",
        };
        let searchParmas = {};
        this.auditStatusType = this.activeName;
        switch (this.auditStatusType) {
          case "pending":
            parmasByType.auditStatus = 1;
            break;
          case "passed":
            parmasByType.auditStatus = 2;
            break;
          case "rejected":
            parmasByType.auditStatus = 3;
            break;
          case "frozen":
            parmasByType.accountStatus = 3;
            break;
        }
        if (parmasByType.accountStatus) {
          searchParmas = {
            tenantId: this.$commonJs.getTenantId(),
            pageNo: this.paginationDataProduct.currentPage,
            pageSize: this.paginationDataProduct.pageSize,
            accountStatus: parmasByType.accountStatus || null,
            businessId: this.searchInfo.bussinessId || null,
          };
        } else {
          searchParmas = {
            tenantId: this.$commonJs.getTenantId(),
            pageNo: this.paginationDataProduct.currentPage,
            pageSize: this.paginationDataProduct.pageSize,
            auditStatus: parmasByType.auditStatus || null,
            businessId: this.searchInfo.bussinessId || null,
          };
        }
        //根据所属状态的数据集合来请求对应数据题分页数据
        this.BusinessAccountInfo(searchParmas);
      } else {
        this.paginationDataProduct = val;
        this.BusinessAccountInfo();
      }
    },
    //审核状态文章数量
    getAllArticleCounts(searchParmas) {
      if (!searchParmas) {
        searchParmas = {
          tenantId: this.$commonJs.getTenantId(),
        };
      }
      delete searchParmas.auditStatus;
      delete searchParmas.accountStatus;
      queryBusinessAccountCount(searchParmas).then((res) => {
        this.businessAccountCountStaus = res;
      });
    },
    //更新创作者状态
    changheBusinessAccountStatus(propData, type) {
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        contentUserManId: propData.contentUserManId,
        contentBusinessId: propData.contentBusinessId,
        accountStatus: type == "freeze" ? 3 : 2,
        auditRemarks: this.modalData.freezeReason,
      };
      console.log("请求 ", params);
      changheBusinessAccountStatus(params).then((res) => {
        console.log("resres", res);
        if (res) {
          this.$message.success(`${type == "freeze" ? "冻结" : "解冻"}成功`);
          this.paginationChangeProduct();
        } else {
          this.$message.error("修改失败");
        }
      });
      // changheBusinessAccountStatus({
      //   tenantId: this.$commonJs.getTenantId(),
      //   businessAccountId:propData.businessAccountId,
      //   accountStatus:3,
      //   pin:propData.pin,
      //   accountRemarks:this.modalData.freezeReason,
      // }).then(res=>{
      //   this.BusinessAccountInfo()
      // })
    },
  },
  created() {
    //获取业务账号信息
    this.BusinessAccountInfo();
    // //获取租户下的角色信息
    // this.getPageContentRole();
    //获取运营相关的业务信息
    this.getListContentBusinessForUserMan();
    //获取文章状态
    this.getAllArticleCounts();
    // this.getPageContentRole();
  },
};
</script>

<style scoped lang="scss">
.el-checkbox-group {
  max-height: 250px;
  overflow-y: scroll;
}
.contentShow {
  margin-top: 15px;
  .contentShow-header {
    margin-top: 30px;
  }
}
.searchIpt-all {
  display: inline-block;
  margin-left: 20px;
  .searchIpt {
    width: 276px;
  }
  .searchIpt-btn {
    margin-left: 2px;
    /*height: 38px;*/
  }
}
.rejectInp {
  max-height: 130px;
  max-width: 276px;
  overflow: hidden;
}
:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}
:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}
.freezeDom {
  margin-top: 30px;
  .freezeInp {
    max-height: 130px;
    max-width: 276px;
    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }
  .mar-top30 {
    margin-top: 30px;
  }
}
.width276 {
  width: 276px;
}
.width90 {
  width: 90px;
}
.width182 {
  width: 182px;
}
.marRig4 {
  margin-right: 4px;
}
.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}
</style>
